/* eslint-disable no-underscore-dangle */
/* eslint-disable global-require */
import IntlPolyfill from 'intl'

import 'intl/locale-data/jsonp/es'
import 'intl/locale-data/jsonp/en'
import 'intl/locale-data/jsonp/eu'

IntlPolyfill.__disableRegExpRestore()

/* eslint-disable-next-line */
declare const Intl: any

Intl.NumberFormat = IntlPolyfill.NumberFormat
Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat

if (!Intl.PluralRules) {
  require('@formatjs/intl-pluralrules/polyfill')
  require('@formatjs/intl-pluralrules/locale-data/es')
  require('@formatjs/intl-pluralrules/locale-data/en')
  require('@formatjs/intl-pluralrules/locale-data/eu')
}
if (!Intl.RelativeTimeFormat) {
  require('@formatjs/intl-relativetimeformat/polyfill')
  require('@formatjs/intl-relativetimeformat/locale-data/es')
  require('@formatjs/intl-relativetimeformat/locale-data/en')
  require('@formatjs/intl-relativetimeformat/locale-data/eu')
}
